import { render } from "./MessageHTML.vue?vue&type=template&id=2aa40978"
import script from "./MessageHTML.vue?vue&type=script&lang=js"
export * from "./MessageHTML.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__